import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correction.finishedConfirmation.title',
    defaultMessage: 'FINISHED',
  },
  subtitle: {
    id: 'simulated.correction.finishedConfirmation.subtitle',
    defaultMessage:
      'The {idEvaluation} - {evaluationName} evaluation has been finished.<br/>If the answer sheets of the students present have already been uploaded and the flagged audits have already been done, the answer sheet upload process was completed successfully.<br/>The Assessment team has already been notified and no further action is required.',
  },
  errorTitle: {
    id: 'simulated.correction.finishedConfirmation.errorTitle',
    defaultMessage: 'REQUEST NOT COMPLETED',
  },
  errorSubtitle: {
    id: 'simulated.correction.finishedConfirmation.errorSubtitle',
    defaultMessage:
      'We could not finish the {idEvaluation} - {evaluationName} evaluation. Please try again in a few moments or contact support.',
  },
  continue: {
    id: 'simulated.correction.finishedConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
